<template>
  <div id="user">
    <el-container class="container">
      <el-main class="main">
        <div class="main-in">
          <p style="color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 19px;">我的预约</p>
          <el-menu default-active="1" class="el-menu-demo" mode="horizontal" text-color="#000"
            active-text-color="#77BA00">
            <el-menu-item index="1">全部</el-menu-item>
            <el-menu-item index="2">已预约</el-menu-item>
            <el-menu-item index="3">正在处理</el-menu-item>
            <el-menu-item index="4">已完成</el-menu-item>
          </el-menu>
          <div class="reserved">
            <div class="reserved-t">
              <span>
                <span>
                  <span class="key">服务项目 : </span>
                  <span class="value">DGX A800</span>
                </span>
                <span>
                  <span class="key">合同编号 : </span>
                  <span class="value">2021100120221001</span>
                </span>
                <span>
                  <span class="key">产品数量 : </span>
                  <span class="value">10台</span>
                </span>
                <span>
                  <span class="key">服务期限 : </span>
                  <span class="value">2021/1/1 - 2030/1/1</span>
                </span>
              </span>
              <span style="color:#77BA00;
font-size: 14px;
font-weight: 500;">已预约</span>
            </div>
            <div class="reserved-c">
              <div style="margin-bottom:24px;display: flex">
                <span class="key">预约详情：</span>
                <span class="value" style="margin-right: 0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div class="reply" style="display: flex">
                <span class="key">回复：</span>
                <span class="value" style="margin-right:0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div style="display:flex;justify-content: flex-end;margin-top: 24px;">
                <el-button size="small" type="success">取消预约</el-button>
              </div>
            </div>
          </div>
          <div class="reserved">
            <div class="reserved-t">
              <span>
                <span>
                  <span class="key">服务项目 : </span>
                  <span class="value">DGX A800</span>
                </span>
                <span>
                  <span class="key">合同编号 : </span>
                  <span class="value">2021100120221001</span>
                </span>
                <span>
                  <span class="key">产品数量 : </span>
                  <span class="value">10台</span>
                </span>
                <span>
                  <span class="key">服务期限 : </span>
                  <span class="value">2021/1/1 - 2030/1/1</span>
                </span>
              </span>
              <span style="color:#77BA00;
font-size: 14px;
font-weight: 500;">正在处理</span>
            </div>
            <div class="reserved-c">
              <div style="margin-bottom:24px;display: flex">
                <span class="key">预约详情：</span>
                <span class="value" style="margin-right: 0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div class="reply" style="display: flex;margin-bottom: 24px;">
                <span class="key">回复：</span>
                <span class="value" style="margin-right:0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div class="reply" style="display: flex;margin-bottom: 24px;
border: 1px solid #D8D8D8;background-color:#fff;">
                <span class="key">咨询：</span>
                <span class="value" style="margin-right:0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div class="reply" style="display: flex;margin-bottom: 24px;">
                <span class="key">回复：</span>
                <span class="value" style="margin-right:0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div style="display:flex;justify-content: flex-end;">
                <el-button size="small">完成</el-button>
                <el-button size="small" type="success">发送</el-button>
              </div>
            </div>
          </div>
          <div class="reserved">
            <div class="reserved-t">
              <span>
                <span>
                  <span class="key">服务项目 : </span>
                  <span class="value">DGX A800</span>
                </span>
                <span>
                  <span class="key">合同编号 : </span>
                  <span class="value">2021100120221001</span>
                </span>
                <span>
                  <span class="key">产品数量 : </span>
                  <span class="value">10台</span>
                </span>
                <span>
                  <span class="key">服务期限 : </span>
                  <span class="value">2021/1/1 - 2030/1/1</span>
                </span>
              </span>
              <span style="color:#77BA00;
font-size: 14px;
font-weight: 500;">处理完成</span>
            </div>
            <div class="reserved-c">
              <div style="margin-bottom:24px;display: flex">
                <span class="key">预约详情：</span>
                <span class="value" style="margin-right: 0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
              <div class="reply" style="display: flex">
                <span class="key">回复：</span>
                <span class="value" style="margin-right:0;">NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                  平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型</span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination style="text-align:right" background layout="prev, pager, next"
              :total="1000">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  background-color: #f5f5f5;
}
.main-in {
  background-color: #fff;
  padding: 24px;
}
.el-menu-item.is-active {
  border-bottom: 2px solid #77ba00;
}

::v-deep .el-menu-item {
  margin-right: 50px !important;
  padding: 0;
}
.reserved {
  margin: 24px 0;
  border: 1px solid #d8d8d8;
}
.reserved-t {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #d8d8d8;
}
.reserved-t span:nth-child(2n) {
  font-size: 14px;
}
.key {
  color: #666666;
  width: 80px;
  font-size: 14px;
}
.value {
  color: #333333;
  margin-right: 48px;
  font-size: 14px;
  line-height: 22px;
}
.reserved-c {
  padding: 29px 24px 24px 24px;
}
.reply {
  background: #f6f8fb;
  padding: 12px 15px;
}
.reply .key {
  width: 47px;
}
.el-button {
  border-radius: 0;
}
::v-deep .el-button--success {
  background-color: #77ba00 !important;
  border-color: #77ba00 !important;
}
.pagination {
  margin-top: 24px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #77ba00;
  border: none;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #606266;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-pagination button {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
